let list = [{
    "title": "主页",
    "icon": "zy",
    "gid": "0",
    "children": []
  },
  {
    "title": "采购管理",
    "icon": "cggl",
    "gid": "2200",
    "children": [{
        "fname": "采购询价",
        "fnaviid": "2211",
        "icon": "icon_dd",
        "color": "#FF7F73"
      },
      {
        "fname": "采购订单",
        "fnaviid": "2231",
        "icon": "icontongji",
        "color": "#E16531"
      },
      {
        "fname": "收货单",
        "fnaviid": "2241",
        "icon": "icon_shd",
        "color": "#39CAD9"
      },
      {
        "fname": "付款单",
        "fnaviid": "2323",
        "icon": "icon_fkd",
        "color": "#3791BF"
      },
      {
        "fname": "退货单",
        "fnaviid": "2261",
        "icon": "icon_thd",
        "color": "#D4237A"
      }
    ]
  },
  {
    "title": "销售管理",
    "icon": "xsgl",
    "gid": "2100",
    "children": [{
        "fname": "客户报价",
        "fnaviid": "2111",
        "icon": "icon_dd",
        "color": "#F86D5F"
      },
      {
        "fname": "客户订单",
        "fnaviid": "2131",
        "icon": "icontongji",
        "color": "#E16531"
      },
      {
        "fname": "送货单",
        "fnaviid": "2311",
        "icon": "icon_shd",
        "color": "#E9554C"
      },
      {
        "fname": "收款单",
        "fnaviid": "2313",
        "icon": "icon_fkd",
        "color": "#FFA044"
      },
      {
        "fname": "调拨单",
        "fnaviid": "2343",
        "icon": "icon_dbd",
        "color": "#A4CAFC"
      },
      {
        "fname": "零售单",
        "fnaviid": "6126",
        "icon": "icon_lsd",
        "color": "#64C070"
      },
      {
        "fname": "退货单",
        "fnaviid": "2161",
        "icon": "icon_thd",
        "color": "#36AB60"
      }
    ]
  },
  {
    "title": "库存管理",
    "icon": "kcgl",
    "gid": "2400",
    "children": [{
        "fname": "库存盘点",
        "fnaviid": "2427",
        "icon": "icon_kcpd",
        "color": "#079BEF"
      },
      {
        "fname": "库存查询",
        "fnaviid": "2401",
        "icon": "icon_kccx",
        "color": "#76CBFF"
      },
      {
        "fname": "库存调拨",
        "fnaviid": "2425",
        "icon": "icon_kcdb",
        "color": "#259EDE"
      },
      {
        "fname": "其他入库",
        "fnaviid": "2428",
        "icon": "icon_qtrk",
        "color": "#FFA342"
      },
      {
        "fname": "其他出库",
        "fnaviid": "2429",
        "icon": "icon_qtck",
        "color": "#97C56B"
      },
      {
        "fname": "报废出库",
        "fnaviid": "2426",
        "icon": "icon_bfck",
        "color": "#AFC5D0"
      }
    ]
  },
  {
    "title": "财务管理",
    "icon": "cwgl",
    "gid": "2300",
    "children": [{
        "fname": "应收对账",
        "fnaviid": "2301",
        "icon": "icon_ysdzd",
        "color": "#1296DB"
      },
      {
        "fname": "送货单",
        "fnaviid": "2311",
        "icon": "icon_shd",
        "color": "#E9554C"
      },
      {
        "fname": "收款单",
        "fnaviid": "2313",
        "icon": "icon_fkd",
        "color": "#FFA044"
      },
      {
        "fname": "应付对账",
        "fnaviid": "2302",
        "icon": "icon_yfdzd",
        "color": "#D4237A"
      },
      {
        "fname": "收料单",
        "fnaviid": "2321",
        "icon": "icon_cgshd",
        "color": "#39CAD9"
      },
      {
        "fname": "付款单",
        "fnaviid": "2323",
        "icon": "icon_fkd",
        "color": "#3791BF"
      },
      {
        "fname": "费用支出",
        "fnaviid": "2331",
        "icon": "icon_zc",
        "color": "#D4797A"
      },
      {
        "fname": "其他收入",
        "fnaviid": "2332",
        "icon": "icon_sr",
        "color": "#44C5D5"
      },
      {
        "fname": "收支账",
        "fnaviid": "2303",
        "icon": "icon_szz",
        "color": "#F89B4D"
      }
    ]
  },
  {
    "title": "办公管理",
    "icon": "bggl",
    "gid": "1000",
    "children": [{
        "fname": "签到考勤",
        "fnaviid": "1111",
        "icon": "icon_qdkq",
        "color": "#30DAFF"
      },
      {
        "fname": "请假申请",
        "fnaviid": "1112",
        "icon": "icon_qjsq",
        "color": "#3399FF"
      },
      {
        "fname": "办公通讯",
        "fnaviid": "1113",
        "icon": "icon_txl",
        "color": "#64C070"
      },
      {
        "fname": "审批申请",
        "fnaviid": "1114",
        "icon": "icon_spsq",
        "color": "#3C738A"
      },
      {
        "fname": "个人中心",
        "fnaviid": "1991",
        "icon": "icon_grzx",
        "color": "#11AAED"
      }
    ]
  },
  {
    "title": "基础资料",
    "icon": "jczl",
    "gid": "4100",
    "children": [{
        "fname": "产品资料",
        "fnaviid": "4111",
        "icon": "icon_cpzl",
        "color": "#34913A"
      },
      {
        "fname": "部门员工",
        "fnaviid": "4113",
        "icon": "icon_bmyg",
        "color": "#11AAED"
      },
      {
        "fname": "辅助资料",
        "fnaviid": "6199",
        "icon": "icon_fzzl",
        "color": "#29AB93"
      },
      {
        "fname": "品牌产品库",
        "fnaviid": "4120",
        "icon": "icon_fzzl",
        "color": "#29AB93"
      }
    ]
  },
  {
    "title": "决策分析",
    "icon": "jcfx",
    "gid": "5100",
    "children": [{
        "fname": "采购报表",
        "fnaviid": "51001",
        "icon": "",
        "color": "#FF7F73"
      },
      {
        "fname": "销售报表",
        "fnaviid": "51002",
        "icon": "",
        "color": "#FF7F73"
      },
      {
        "fname": "库存报表",
        "fnaviid": "51003",
        "icon": "",
        "color": "#FF7F73"
      },
      {
        "fname": "财务报表",
        "fnaviid": "51004",
        "icon": "",
        "color": "#FF7F73"
      }
    ]
  },
  {
    "title": "系统管理",
    "icon": "xtgl",
    "gid": "9100",
    "children": [{
        "fname": "授权中心",
        "fnaviid": "9111",
        "icon": "icon_sqzx",
        "color": "#2EAD96"
      },
      {
        "fname": "角色管理",
        "fnaviid": "9112",
        "icon": "icon_sqzx",
        "color": "#2EAD96"
      },
      {
        "fname": "用户审批",
        "fnaviid": "9121",
        "icon": "icon_sqzx",
        "color": "#2EAD96"
      },
      {
        "fname": "数据中心",
        "fnaviid": "9312",
        "icon": "icon_sjzx",
        "color": "#118EE9"
      },

      {
        "fname": "设计模板",
        "fnaviid": "9115",
        "icon": "icon_sqzx",
        "color": "#2EAD96"
      },
      {
        "fname": "资料设计",
        "fnaviid": "9113",
        "icon": "icon_sjzx",
        "color": "#118EE9"
      }
    ]
  },
]
let toolList = [{
    title: '购货',
    icon: 'htoolgh',
    "class": "hlmi-group2",
    children: [{
        name: '采购单据',
        list: [{
            name: '采购订单',
            code: 'cgdd',
            fnaviid: 2231,
            ishot: true
          },
          {
            name: '收货单',
            code: 'shdcg',
            fnaviid: 2321
          }
        ]
      },
      {
        name: '采购报表',
        "class": "hlmi-group2",
        list: [{
            name: '采购订单跟踪表',
            code: 'cgddgzb',
            fnaviid: 2231
          },
          {
            name: '采购明细表',
            code: 'cgmxb',
            fnaviid: 2231
          },
          {
            name: '采购汇总表(按商品)',
            code: 'cghzbsp',
            fnaviid: 2231
          },
          {
            name: '采购汇总表(按供应商)',
            code: 'cghzbgys',
            fnaviid: 2231
          },
          {
            name: '采购付款一览表',
            code: 'cgfkylb',
            fnaviid: 2231
          }
        ]
      },
    ]
  },
  {
    title: '销货',
    icon: 'htoolxh',
    "class": "hlmi-group2",
    children: [{
        name: '销售单据',
        list: [{
            name: '报价单',
            code: 'bjd',
            fnaviid: 2111
          },
          {
            name: '客户订单',
            code: 'khdd',
            fnaviid: 2131
          },
          {
            name: '送货单',
            code: 'shdxh',
            fnaviid: 2311
          }
        ]
      },
      {
        name: '销售报表',
        "class": "hlmi-group2",
        list: [{
            name: '销售订单跟踪表',
            code: 'xsddgzb',
            fnaviid: 2231
          },
          {
            name: '销售明细表',
            code: 'xsmxb',
            fnaviid: 2231
          },
          {
            name: '销售汇总表(按商品)',
            code: 'xshzbsp',
            fnaviid: 2231
          },
          {
            name: '销售汇总表(按客户)',
            code: 'xshzbkh',
            fnaviid: 2231
          },
          {
            name: '销售汇总表(按销售人员)',
            code: 'xshzbxsry',
            fnaviid: 2231
          },
          {
            name: '销售收款一览表',
            code: 'xsskylb',
            fnaviid: 2231
          },
          // {name:'往来单位欠款表',code:'wldwqkb',fnaviid:2231}
        ]
      },
    ]
  },
  {
    title: '仓库',
    icon: 'htoolck',
    "class": "hlmi-group2",
    children: [{
        name: '仓库单据',
        list: [{
            name: '库存调拨',
            code: 'kcdb',
            fnaviid: 2425
          },
          {
            name: '库存查询',
            code: 'kccx',
            fnaviid: 2401
          },
          {
            name: "总部库存",
            code: 'zbkc',
            fnaviid: 1414
          },
          {
            name: '库存盘点',
            code: 'kcpd',
            fnaviid: 2427
          },
          {
            name: '其它入库',
            code: 'qtrk',
            fnaviid: 2428
          },
          {
            name: '其它出库',
            code: 'qtck',
            fnaviid: 2429
          },
          {
            name: '报废出库',
            code: 'bfck',
            fnaviid: 2426
          }
        ]
      },
      {
        name: '仓库报表',
        list: [
          // {name:'商品库存余额表',code:'spkcyeb',fnaviid:2231},
          {
            name: '商品收发明细表',
            code: 'spsfmxb',
            fnaviid: 2231
          },
          {
            name: '商品收发汇总表',
            code: 'spsfhzb',
            fnaviid: 2231
          }
        ]
      },
    ]
  },
  {
    title: '资金',
    icon: 'htoolzj',
    "class": "hlmi-group2",
    children: [{
        name: '资金单据',
        list: [{
            name: '收款单',
            code: 'skd',
            fnaviid: 2313
          },
          {
            name: '付款单',
            code: 'fkd',
            fnaviid: 2323
          },
          {
            name: '其它收入',
            code: 'qtsr',
            fnaviid: 2332
          },
          {
            name: '其它支出',
            code: 'qtzc',
            fnaviid: 2331
          }
        ]
      },
      {
        name: '资金报表',
        list: [{
            name: '应付账款明细表',
            code: 'yfzkmxb',
            fnaviid: 2231
          },
          {
            name: '应收账款明细表',
            code: 'yszkmxb',
            fnaviid: 2231
          },
          {
            name: '应收对账',
            code: 'ysdz',
            fnaviid: 2231
          },
          {
            name: '应付对账',
            code: 'yfdz',
            fnaviid: 2231
          },
          {
            name: '其它收支明细表',
            code: 'qtszmxb',
            fnaviid: 2231
          },
          // {name:'往来对账',code:'wljz',fnaviid:2231}
        ]
      },
    ]
  },

  {
    title: '资料',
    icon: 'htoolzl',
    "class": "hlmi-group2",
    children: [{
        name: '基础资料',
        list: [{
            name: '商品资料',
            code: 'spzl',
            fnaviid: 4111
          },
          {
            name: '辅助资料',
            code: 'fzzl',
            fnaviid: 4199
          },
          // {name:'报价客户',code:'wldwnco',fnaviid:4142},
          // {name:'往来单位',code:'wldw',fnaviid:4112},
          {
            name: '客户资料',
            code: 'khzl',
            fnaviid: 4131
          },
          {
            name: '供方资料',
            code: 'gfzl',
            fnaviid: 4132
          },
          {
            name: '部门员工',
            code: 'bmyg',
            fnaviid: 4113
          },
          {
            name: '仓库仓位',
            code: 'ckcw',
            fnaviid: 4114
          },
          {
            name: '账户资料',
            code: 'zhzl',
            fnaviid: 4122
          }
        ]
      },
      {
        name: '报价资料',
        list: [{
            name: '报价资料',
            code: 'spzlnco',
            fnaviid: 4141
          },
          {
            name: '报价客户',
            code: 'wldwnco',
            fnaviid: 4142
          },
        ]
      },
      // {name:'辅助资料',list:[
      //                 {name:'商品类别',code:'splb',fnaviid:2231},
      //                 {name:'往来单位类别',code:'wldwlb',fnaviid:2231},
      //                 {name:'支出类别',code:'zclb',fnaviid:2231},
      //                 {name:'收入类别',code:'srlb',fnaviid:2231},
      //                 {name:'计量单位',code:'jldw',fnaviid:2231},
      //                 {name:'结算方式',code:'jsfs',fnaviid:2231},
      //                 {name:'客户物料编码',code:'khwlbm',fnaviid:2231},
      //                 {name:'发货地址管理',code:'fhdzgl',fnaviid:2231}
      //                 ]},
    ]
  },
  {
    title: '办公',
    icon: 'htoolbg',
    "class": "hlmi-group2",
    children: [{
      name: '轻办公',
      list: [{
          name: '流程审批',
          code: 'lcsp',
          fnaviid: 1012
        },
        {
          name: '知识中心',
          code: 'zszx',
          fnaviid: 1117
        }
      ]
    }]
  },
  {
    title: '设置',
    icon: 'htoolsz',
    "class": "hlmi-group2",
    children: [{
        name: '用户设置',
        list: [{
            name: '授权中心',
            code: 'sqzx',
            fnaviid: 2231
          },
          {
            name: '系统设置',
            code: 'xtsz',
            fnaviid: 2231
          },
          {
            name: '日志中心',
            code: 'rzzx',
            fnaviid: 2231
          },
          // { name: '数据维护', code: 'sjwh', fnaviid: 2231 },
          {
            name: '系统初始化',
            code: 'xtcsh',
            fnaviid: 2231
          },
          {
            name: '帮助中心',
            code: 'bzzx',
            fnaviid: 9996
          },
        ]
      },
      {
        name: '开发设置',
        list: [{
            name: '办公流程',
            code: 'bglc',
            fnaviid: 1012
          },
          {
            name: '系统配置',
            code: 'xtpz',
            fnaviid: 2231
          },
          {
            name: '报表设计',
            code: 'bbsj',
            fnaviid: 9114
          },
          {
            name: '模板中心',
            code: '9272',
            fnaviid: 2231
          },
          {
            name: '数据配置',
            code: 'sjpz',
            fnaviid: 9312
          },
        ]
      },
    ]
  },
]
let toolList2 = [{
    title: '购货',
    icon: 'htoolgh',
    children: [{
        name: '采购订单',
        code: 'cgdd',
        fnaviid: 2231
      },
      {
        name: '收货单',
        code: 'shdcg',
        fnaviid: 2321
      },
      {
        name: '采购订单跟踪表',
        code: 'cgddgzb',
        fnaviid: 2231
      },
      {
        name: '采购明细表',
        code: 'cgmxb',
        fnaviid: 2231
      },
      {
        name: '采购汇总表(按商品)',
        code: 'cghzbsp',
        fnaviid: 2231
      },
      {
        name: '采购汇总表(按供应商)',
        code: 'cghzbgys',
        fnaviid: 2231
      },
      {
        name: '采购付款一览表',
        code: 'cgfkylb',
        fnaviid: 2231
      }
    ]
  },
  {
    title: '销货',
    icon: 'htoolxh',
    children: [{
        name: '报价单',
        code: 'bjd',
        fnaviid: 2111
      },
      {
        name: '快速报价',
        code: 'ksbj',
        fnaviid: 2112
      },
      {
        name: '客户订单',
        code: 'khdd',
        fnaviid: 2131
      },
      {
        name: '送货单',
        code: 'shdxh',
        fnaviid: 2311
      },
      {
        name: '销售订单跟踪表',
        code: 'xsddgzb',
        fnaviid: 2231
      },
      {
        name: '销售明细表',
        code: 'xsmxb',
        fnaviid: 2231
      },
      {
        name: '销售汇总表(按商品)',
        code: 'xshzbsp',
        fnaviid: 2231
      },
      {
        name: '销售汇总表(按客户)',
        code: 'xshzbkh',
        fnaviid: 2231
      },
      {
        name: '销售汇总表(按销售人员)',
        code: 'xshzbxsry',
        fnaviid: 2231
      },
      {
        name: '销售收款一览表',
        code: 'xsskylb',
        fnaviid: 2231
      },
      // {name:'往来单位欠款表',code:'wldwqkb',fnaviid:2231}
    ]
  },
  {
    title: '仓库',
    icon: 'htoolck',
    children: [{
        name: '库存调拨',
        code: 'kcdb',
        fnaviid: 2425
      },
      {
        name: '库存盘点',
        code: 'kcpd',
        fnaviid: 2427
      },
      {
        name: '其它入库',
        code: 'qtrk',
        fnaviid: 2428
      },
      {
        name: '其它出库',
        code: 'qtck',
        fnaviid: 2429
      },
      {
        name: '报废出库',
        code: 'bfck',
        fnaviid: 2426
      },
      {
        name: '库存查询',
        code: 'kccx',
        fnaviid: 2401
      },
      {
        name: '总部库存',
        code: 'zbkc',
        fnaviid: 1414
      },
      // {name:'商品库存余额表',code:'spkcyeb',fnaviid:2231},
      {
        name: '商品收发明细表',
        code: 'spsfmxb',
        fnaviid: 2231
      },
      {
        name: '商品收发汇总表',
        code: 'spsfhzb',
        fnaviid: 2231
      }
    ]
  },
  {
    title: '资金',
    icon: 'htoolzj',
    children: [{
        name: '收款单',
        code: 'skd',
        fnaviid: 2313
      },
      {
        name: '付款单',
        code: 'fkd',
        fnaviid: 2323
      },
      {
        name: '其它收入',
        code: 'qtsr',
        fnaviid: 2332
      },
      {
        name: '其它支出',
        code: 'qtzc',
        fnaviid: 2331
      },
      {
        name: '应付账款明细表',
        code: 'yfzkmxb',
        fnaviid: 2231
      },
      {
        name: '应收账款明细表',
        code: 'yszkmxb',
        fnaviid: 2231
      },
      {
        name: '应收对账',
        code: 'ysdz',
        fnaviid: 2231
      },
      {
        name: '应付对账',
        code: 'yfdz',
        fnaviid: 2231
      },
      {
        name: '其它收支明细表',
        code: 'qtszmxb',
        fnaviid: 2231
      },
      // {name:'往来对账',code:'wljz',fnaviid:2231}
    ]
  },
  {
    title: '资料',
    icon: 'htoolzl',
    children: [{
        name: '商品资料',
        code: 'spzl',
        fnaviid: 4111
      },
      {
        name: '辅助资料',
        code: 'fzzl',
        fnaviid: 4199
      },
      {
        name: '报价客户',
        code: 'wldwnco',
        fnaviid: 4142
      },
      {
        name: '客户资料',
        code: 'khzl',
        fnaviid: 4131
      },
      {
        name: '供方资料',
        code: 'gfzl',
        fnaviid: 4132
      },
      {
        name: '部门员工',
        code: 'bmyg',
        fnaviid: 4113
      },
      {
        name: '仓库仓位',
        code: 'ckcw',
        fnaviid: 4114
      },
      {
        name: '账户资料',
        code: 'zhzl',
        fnaviid: 4122
      },
    ]
  },
  // {title:'办公',icon:'htoolzl',children:[]},

  {
    title: '设置',
    icon: 'htoolsz',
    children: [{
        name: '模板中心',
        code: '4111',
        fnaviid: 4111
      },
      {
        name: '报表设计',
        code: 'bbsj',
        fnaviid: 9114
      },
      {
        name: '系统配置',
        code: 'xtpz',
        fnaviid: 2231
      },
      {
        name: '系统设置',
        code: 'xtsz',
        fnaviid: 2231
      },
      {
        name: '授权中心',
        code: 'sqzx',
        fnaviid: 2231
      },
      {
        name: '日志中心',
        code: 'rzzx',
        fnaviid: 2231
      },
      // { name: '数据维护', code: 'sjwh', fnaviid: 2231 },
      {
        name: '系统初始化',
        code: 'xtcsh',
        fnaviid: 2231
      },
    ]
  },
]
let oftenList = [{
    name: '购货',
    children: [{
        name: '采购订单',
        code: 'cgdd',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2231.png',
        fnaviid: 2231
      },
      {
        name: '收货单',
        code: 'shdcg',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2312.png',
        fnaviid: 2321
      },
      {
        name: '采购订单跟踪表',
        code: 'cgddgzb',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '采购明细表',
        code: 'cgmxb',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '采购汇总表(按商品)',
        code: 'cghzbsp',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '采购汇总表(按供应商)',
        code: 'cghzbgys',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '采购付款一览表',
        code: 'cgfkylb',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      }
    ]
  },
  {
    name: '销货',
    children: [{
        name: '报价单',
        code: 'bjd',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2322.png',
        fnaviid: 2111
      },
      {
        name: '快速报价',
        code: 'ksbj',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2322.png',
        fnaviid: 2112
      },
      {
        name: '客户订单',
        code: 'khdd',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2131.png',
        fnaviid: 2131
      },
      {
        name: '送货单',
        code: 'shdxh',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2311.png',
        fnaviid: 2311
      },
      {
        name: '销售订单跟踪表',
        code: 'xsddgzb',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '销售明细表',
        code: 'xsmxb',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '销售汇总表(按商品)',
        code: 'xshzbsp',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '销售汇总表(按客户)',
        code: 'xshzbkh',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '销售汇总表(按销售人员)',
        code: 'xshzbxsry',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '销售付款一览表',
        code: 'xsfkylb',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      // {name:'往来单位欠款表',code:'wldwqkb',checked:false,src:'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png?AccessKeyId=QTEZALFEWXYLBIPF1ZXH&Expires=1668133107&Signature=xSnDOMC/pQnTX6iirTk7aOlwiD0%3D',fnaviid:2231}
    ]
  },
  {
    name: '仓库',
    children: [{
        name: '库存调拨',
        code: 'kcdb',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2425.png',
        fnaviid: 2425
      },
      {
        name: '库存盘点',
        code: 'kcpd',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2447.png',
        fnaviid: 2427
      },
      {
        name: '其它入库',
        code: 'qtrk',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2421.png',
        fnaviid: 2428
      },
      {
        name: '其它出库',
        code: 'qtck',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2429.png',
        fnaviid: 2429
      },
      {
        name: '报废出库',
        code: 'bfck',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2426.png',
        fnaviid: 2426
      },
      {
        name: '库存查询',
        code: 'kccx',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2401.png',
        fnaviid: 2401
      },
      {
        name: '总部库存',
        code: 'zbkc',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2401.png',
        fnaviid: 1414
      },
      // {name:'商品库存余额表',code:'spkcyeb',checked:false,src:'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png?AccessKeyId=QTEZALFEWXYLBIPF1ZXH&Expires=1668133107&Signature=xSnDOMC/pQnTX6iirTk7aOlwiD0%3D',fnaviid:2231},
      {
        name: '商品收发明细表',
        code: 'spsfmxb',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '商品收发汇总表',
        code: 'spsfhzb',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      }
    ]
  },
  {
    name: '资金',
    children: [{
        name: '收款单',
        code: 'skd',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2313.png',
        fnaviid: 2313
      },
      {
        name: '付款单',
        code: 'fkd',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2323.png',
        fnaviid: 2323
      },
      {
        name: '其它收入',
        code: 'qtsr',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2332.png',
        fnaviid: 2332
      },
      {
        name: '其它支出',
        code: 'qtzc',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/2331.png',
        fnaviid: 2331
      },
      {
        name: '应付账款明细表',
        code: 'yfzkmxb',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '应收账款明细表',
        code: 'yszkmxb',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '应收对账',
        code: 'ysdz',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '应付对账',
        code: 'yfdz',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      {
        name: '其它收支明细表',
        code: 'qtszmxb',
        checked: false,
        src: 'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png',
        fnaviid: 2231
      },
      // {name:'往来对账',code:'wljz',checked:false,src:'https://ncktc.obs.cn-south-1.myhuaweicloud.com:443/erp/navi/5101.png?AccessKeyId=QTEZALFEWXYLBIPF1ZXH&Expires=1668133107&Signature=xSnDOMC/pQnTX6iirTk7aOlwiD0%3D',fnaviid:2231}
    ]
  }
]

let homeList = [{
    fname: '采购询价',
    fnaviid: '2211',
    icon: 'icon_dd',
    color: '#FF7F73'
  },
  {
    fname: '采购订单',
    fnaviid: '2231',
    icon: 'icontongji',
    color: '#E16531'
  },
  {
    fname: '收货单',
    fnaviid: '2241',
    icon: 'icon_shd',
    color: '#39CAD9'
  },
  {
    fname: '付款单',
    fnaviid: '2323',
    icon: 'icon_fkd',
    color: '#3791BF'
  },
  {
    fname: '退货单',
    fnaviid: '2261',
    icon: 'icon_thd',
    color: '#D4237A'
  },
  {
    fname: '库存盘点',
    fnaviid: '2427',
    icon: 'icon_kcpd',
    color: '#079BEF'
  },
  {
    fname: '库存查询',
    fnaviid: '2401',
    icon: 'icon_kccx',
    color: '#76CBFF'
  },
  {
    fname: '库存调拨',
    fnaviid: '2425',
    icon: 'icon_kcdb',
    color: '#259EDE'
  },
]
let printList = [{
    naviname: '采购订单',
    naviid: 2231
  },
  {
    naviname: '收货单',
    naviid: 2321
  },
  {
    naviname: '报价单',
    naviid: 2111
  },
  {
    naviname: '客户订单',
    naviid: 2131
  },
  {
    naviname: '送货单',
    naviid: 2311
  },
  {
    naviname: '库存调拨',
    naviid: 2425
  },
  {
    naviname: '库存盘点',
    naviid: 2427
  },
  {
    naviname: '其它入库',
    naviid: 2428
  },
  {
    naviname: '其它出库',
    naviid: 2429
  },
  {
    naviname: '报废出库',
    naviid: 2426
  },
  {
    naviname: '库存查询',
    naviid: 2401
  },
  {
    naviname: '收款单',
    naviid: 2313
  },
  {
    naviname: '付款单',
    naviid: 2323
  },
  {
    naviname: '其它收入',
    naviid: 2332
  },
  {
    naviname: '其它支出',
    naviid: 2331
  },
  {
    naviname: '商品资料',
    naviid: 4111
  },
  {
    naviname: '辅助资料',
    naviid: 4199
  },
  {
    naviname: '客户资料',
    naviid: 4131
  },
  {
    naviname: '供方资料',
    naviid: 4132
  },
  {
    naviname: '部门员工',
    naviid: 4113
  },
  {
    naviname: '仓库仓位',
    naviid: 4114
  },
  {
    naviname: '账户资料',
    naviid: 4122
  },
  {
    naviname: '采购订单跟踪表',
    naviid: -1,
    keyword: 'agt/proc/order/trace'
  },
  {
    naviname: '采购明细表',
    naviid: -1,
    keyword: 'agt/proc/detail'
  },
  {
    naviname: '采购汇总表(按商品)',
    naviid: -1,
    keyword: 'agt/proc/sum/bymat'
  },
  {
    naviname: '采购汇总表(按供应商)',
    naviid: -1,
    keyword: 'agt/proc/sum/bycs'
  },
  {
    naviname: '采购付款一览表',
    naviid: -1,
    keyword: ''
  },
  {
    naviname: '销售订单跟踪表',
    naviid: -1,
    keyword: 'agt/sale/order/trace'
  },
  {
    naviname: '销售明细表',
    naviid: -1,
    keyword: 'agt/sale/detail'
  },
  {
    naviname: '销售汇总表(按商品)',
    naviid: -1,
    keyword: 'agt/sale/sum/bymat'
  },
  {
    naviname: '销售汇总表(按客户)',
    naviid: -1,
    keyword: 'agt/sale/sum/bycs'
  },
  {
    naviname: '销售汇总表(按销售人员)',
    naviid: -1,
    keyword: 'agt/sale/sum/byworker'
  },
  {
    naviname: '销售收款一览表',
    naviid: -1,
    keyword: ''
  },
  {
    naviname: '商品收发明细表',
    naviid: -1,
    keyword: ''
  },
  {
    naviname: '商品收发汇总表',
    naviid: -1,
    keyword: ''
  },
  {
    naviname: '应付账款明细表',
    naviid: -1,
    keyword: ''
  },
  {
    naviname: '应收账款明细表',
    naviid: -1,
    keyword: ''
  },
  {
    naviname: '应收对账',
    naviid: -1,
    keyword: ''
  },
  {
    naviname: '应付对账',
    naviid: -1,
    keyword: ''
  },
  {
    naviname: '其它收支明细表',
    naviid: -1,
    keyword: ''
  },
]

// // 动态列的数据
// let ppList = [
//   {prop: "ywrq", label: "业务日期", width: "80", align:'center'},
//   {prop: "djbh", label: "单据编号", width: "80", align:'center'},
//   {prop: "gysmc", label: "供应商名称", width: "80", align:'center'},
//   {prop: "spmc", label: "商品名称", width: "80", align:'center'},
//   {prop: "sl", label: "数量", width: "80", align:'center'},
//   {prop: "yfje", label: "应付金额", width: "80", align:'center'},
//   {prop: "fje", label: "已付金额", width: "80", align:'center'},
//   {prop: "bz", label: "备注", width: "80", align:'center'},
//   {prop: "cz", label: "操作", width: "80", align:'center'}
// ]


// let tbList = [
//   {ywrq:'2020-12-11',djbh:'100001',gysmc:'华为',spmc:'p40',sl:'20',yfje:'20.00',fje:'30.20',bz:'这是一个备注'}
// ]


const datalist = {
  list,
  homeList,
  toolList,
  oftenList,
  toolList2,
  printList
}

export default datalist //导出



// WEBPACK FOOTER //
// ./src/assets/unit/datalist.js